/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FileListComponent} from './file-list.component';
import {FilePreviewModule} from '../file-preview/file-preview.module';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';


@NgModule({
    declarations: [FileListComponent],
    imports: [
        CommonModule,
        FilePreviewModule,
        LoadingSpinnerModule
    ],
    exports: [FileListComponent]
})

export class FileListModule {
}
